export var HostRunFailureReason;
(function (HostRunFailureReason) {
    HostRunFailureReason[HostRunFailureReason["UnknownError"] = 0] = "UnknownError";
    HostRunFailureReason[HostRunFailureReason["HostOffline"] = 10] = "HostOffline";
    HostRunFailureReason[HostRunFailureReason["StepFailed"] = 40] = "StepFailed";
    HostRunFailureReason[HostRunFailureReason["ServiceError"] = 101] = "ServiceError";
    HostRunFailureReason[HostRunFailureReason["TaskTimeout"] = 102] = "TaskTimeout";
    HostRunFailureReason[HostRunFailureReason["RunTimeout"] = 103] = "RunTimeout";
    HostRunFailureReason[HostRunFailureReason["Unavailable"] = 104] = "Unavailable";
    HostRunFailureReason[HostRunFailureReason["FrameworkNotFound"] = 105] = "FrameworkNotFound";
    HostRunFailureReason[HostRunFailureReason["OSNotSupported"] = 114] = "OSNotSupported";
    HostRunFailureReason[HostRunFailureReason["VersionNotSupported"] = 115] = "VersionNotSupported";
    HostRunFailureReason[HostRunFailureReason["InvalidSignature"] = 120] = "InvalidSignature";
    HostRunFailureReason[HostRunFailureReason["InvalidFileSignature"] = 121] = "InvalidFileSignature";
    HostRunFailureReason[HostRunFailureReason["MissingPermission"] = 130] = "MissingPermission";
    HostRunFailureReason[HostRunFailureReason["NotFound"] = 140] = "NotFound";
    HostRunFailureReason[HostRunFailureReason["InvalidScheduleDate"] = 150] = "InvalidScheduleDate";
})(HostRunFailureReason || (HostRunFailureReason = {}));
